/* @flow */

import * as React from 'react';
import ReactDOM from 'react-dom';

import classNames from 'classnames';

import './modal-lightbox.module.css';

type Props = {
    children: React.Node,
    onClose: () => void,
    canClickOutsideToClose?: boolean,
};

export class ModalLightbox extends React.Component<Props> {
    el: HTMLElement;

    static defaultProps = {
        canClickOutsideToClose: false,
    };

    constructor(props: Props) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        let modalRoot = document.getElementById('modal-root');
        // Fallback to creating a new modal root if one doesn't exist
        if (!modalRoot) {
            const newRoot = document.createElement('div');
            newRoot.id = 'modal-root';
            if (document.body) {
                document.body.appendChild(newRoot);
            }
            modalRoot = newRoot;
        }
        modalRoot.appendChild(this.el);
        document.addEventListener('keydown', this.handleKeyDown);

        const body = document.querySelector('body');
        if (body) {
            body.style.overflow = 'hidden';
        }
    }

    componentWillUnmount() {
        const modalRoot = document.getElementById('modal-root');
        if (modalRoot) {
            modalRoot.removeChild(this.el);
        }
        document.removeEventListener('keydown', this.handleKeyDown);

        const body = document.querySelector('body');
        if (body) {
            body.style.overflow = '';
        }
    }

    handleKeyDown: KeyboardEventListener = (e) => {
        // Not using Nut.keys here since it isn't in scope within shells
        // keyCode 27 = Esc
        if (e.keyCode === 27 && !e.defaultPrevented) this.props.onClose();
    };

    handleModalClick = () => {
        if (this.props.canClickOutsideToClose) {
            this.props.onClose();
        }
    };

    render() {
        const appMount = document.getElementById('app-react-mount');
        const isAiAgentSidebarOpen =
            appMount && appMount.getAttribute('data-ai-agent-open') === 'true';

        const modalClassNames = classNames('modal', {
            'ai-agent-sidebar-open': isAiAgentSidebarOpen,
        });

        const underlayClassNames = classNames('underlay', {
            'ai-agent-sidebar-open': isAiAgentSidebarOpen,
        });

        return ReactDOM.createPortal(
            <div styleName={modalClassNames} onClick={this.handleModalClick}>
                <div styleName='body'>{this.props.children}</div>
                <div styleName={underlayClassNames} />
            </div>,
            this.el
        );
    }
}
